import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import Layout from "@/views/layout/index.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    children: [
      {
        path: '',
        name: 'statistics',
        component: () => import('@/views/statistics/index.vue'),
        meta: { title: '统计首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/performance',
    component: Layout,
    children: [
      {
        path: '',
        name: 'performance',
        component: () => import('@/views/performance/index.vue'),
        meta: { title: '绩效管理', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/system',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/system/admin',
    meta: { title: '系统管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '管理员列表', icon: 'el-icon-user' }
      },
      {
        path: 'slideshow',
        name: 'slideshow',
        component: () => import('@/views/slideshow/slideshow.vue'),
        meta: { title: '管理员列表', icon: 'el-icon-user' }
      },


      {
        path: 'role',
        name: 'Role',
        component: () => import('@/views/role/index.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'menu',
        name: 'Menu',
        component: () => import('@/views/menu/index.vue'),
        meta: { title: '菜单管理', icon: 'el-icon-menu' }
      }
    ]
  },
  {
    path: '/user',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/user/user',
    meta: {title: '人员管理', icon: 'el-icon-s-tools'},
    children: [
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/user/user/index.vue'),
        meta: {title: '用户管理', icon: 'el-icon-user'}
      },
      {
        path: 'noUser',
        name: 'noUser',
        component: () => import('@/views/user/noUser/index.vue'),
        meta: {title: '非用户管理', icon: 'el-icon-user'}
      },
      {
        path: 'level',
        name: 'UserLevel',
        component: () => import('@/views/user/level/index.vue'),
        meta: {title: '会员等级', icon: 'el-icon-medal'}
      },
      {
        path: 'businessDocumentPreparation',
        name: 'businessDocumentPreparation',
        component: () => import('@/views/user/businessDocumentPreparation/index.vue'),
        meta: {title: '业务员&制单员', icon: 'el-icon-s-custom'}
      }
    ]
  },
  {
    path: '/product',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/product/product',
    meta: {title: '产品管理', icon: 'el-icon-s-tools'},
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/product/product/index.vue'),
        meta: {title: '产品管理', icon: 'el-icon-user'}
      },
      {
        path: 'category',
        name: 'category',
        component: () => import('@/views/product/category/index.vue'),
        meta: {title: '产品分类', icon: 'el-icon-medal'}
      }
    ]
  },

  {
    path: '/quotation',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/quotation/quotation',
    meta: {title: '报价管理', icon: 'el-icon-s-tools'},
    children: [
      {
        path: 'quotation',
        name: 'quotation',
        component: () => import('@/views/quotation/quotation/index.vue'),
        meta: {title: '报价管理', icon: 'el-icon-user'}
      },

    ]
  },
  {
    path: '/order',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/order/order',
    meta: {title: '订单管理', icon: 'el-icon-s-tools'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/order/order/index.vue'),
        meta: {title: '订单管理', icon: 'el-icon-user'}
      },

    ]
  },
  {
    path: '/company',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/company/basic',
    meta: {title: '企业管理', icon: 'el-icon-s-tools'},
    children: [
      {
        path: 'company',
        name: 'CompanyManage',
        component: () => import('@/views/company/company/index.vue'),
        meta: {title: '公司管理', icon: 'el-icon-office-building'}
      },
      {
        path: 'articleclass',
        name: 'ArticleClass',
        component: () => import('@/views/company/articleclass/list.vue'),
        meta: {title: '文章分类', icon: 'el-icon-folder'}
      },
      {
        path: 'article',
        name: 'Article',
        component: () => import('@/views/company/article/list.vue'),
        meta: {title: '文章管理', icon: 'el-icon-document'}
      }
    ]
  },
  {
    path: '/contract',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/contract/contract',
    meta: {title: '报价管理', icon: 'el-icon-s-tools'},
    children: [
      {
        path: 'contract',
        name: 'contract',
        component: () => import('@/views/contract/contract/contract.vue'),
        meta: {title: '报价管理', icon: 'el-icon-user'}
      },
      {
        path: 'review',
        name: 'review',
        component: () => import('@/views/contract/review/review.vue'),
        meta: {title: '报价管理', icon: 'el-icon-user'}
      },
    ]
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    next()
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
